import { uiConfig as defaultUiConfig } from '../../../../../../../../../../../../common/conf/codes';

const codeSelectionTableUiConfig = {
    ...defaultUiConfig,
    withActions: ['view'],
    properties: {
        displayName: {
            name: 'Cds Code',
            sortable: true,
            nullable: false,
            rowDisplay: true,
            accessorOverride: (v) => {
                return `${v?.cdsCodeDTO?.displayName} (${v?.cdsCodeDTO?.code})`;
            }
        }
    }
};

const codeSelectionTableUiConfigReadOnly = {
    ...defaultUiConfig,
    properties: {
        displayName: {
            ...defaultUiConfig.properties.displayName,
            input: 'valueDisplay'
        },
        codeId: {
            ...defaultUiConfig.properties.codeId,
            input: 'valueDisplay'
        },
        codeSystem: {
            ...defaultUiConfig.properties.codeSystem,
            input: 'valueDisplay'
        },
        codeSystemId: {
            ...defaultUiConfig.properties.codeSystemId,
            input: 'valueDisplay'
        },
        auditId: {
            ...defaultUiConfig.properties.auditId,
            input: 'valueDisplay'
        }
    }
};

export default {
    uiConfigTable: codeSelectionTableUiConfig,
    uiConfigReadOnly: codeSelectionTableUiConfigReadOnly
};
